import React from "react";
// Logo -------------------\
import logo from "../logo.png"
// Bootstrap ------------------------
import { Navbar, Nav, Container } from "react-bootstrap";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaXTwitter,
} from "react-icons/fa6";


function Header() {
  return (
    <Navbar expand="lg" className="bg-white shadow-sm nav-padding">
      <Container className="ps-5 pe-5" fluid>
        <Navbar.Brand href="/">
          <img
            src={logo}
            alt="Logo"
            className="img-fluid"
            style={{ maxHeight: "50px" }}
            />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />

        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/products">Products</Nav.Link>
            <Nav.Link href="/contact">Contact</Nav.Link>
            {/* ////// Socail Media ---------------------- */}
            <div className="d-flex gap-3 ms-lg-4">
             <a href="#" className="text-dark-blue fs-5 social-icon">
                    <FaFacebookF />
                </a>

                <a href="#" className="text-dark-blue fs-5 social-icon">
                    <FaInstagram />
                </a>

                <a href="#" className="text-dark-blue fs-5 social-icon">
                    <FaYoutube />
                </a>

                <a href="#" className="text-dark-blue fs-5 social-icon">
                    <FaLinkedinIn />
                </a>

                <a href="#" className="text-dark-blue fs-5 social-icon">
                    <FaXTwitter />
                </a>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;